import React from 'react';
import "./advancedSecurity.scss";
import CompanyInformation from './sections/companyInformation';
import SectionAdvancedSecurity from "./sections/sectionAdvancedSecurity"
import StepsSecurity from './sections/stepsSecurity';
import Letsgo from '../connectors/letsgo';
import ApiSecurity from './sections/apiSecurity';

function AdvancedSecurity() {
    return (
        <div className='container-advanced-security'>
            <div className='section-advanced-security'>
                <SectionAdvancedSecurity />
            </div>
            <div className='section-company-information'>
                <CompanyInformation />
            </div>
            <div className='section-steps-segurity'>
                <StepsSecurity />
            </div>
            <div className='section-api-segurity'>
                <ApiSecurity/>
            </div>
            <div className='section-letsgo-free '>
                <Letsgo />
            </div>

        </div>
    )
}

export default AdvancedSecurity;